import React from 'react';
import { Icon, Menu } from 'semantic-ui-react';

const PaginationMenu = (props) => {
  let { current, pages, spread, ...rest } = props;
  pages = Math.max(pages, 1);
  current = Math.min(Math.max(current, 1), pages);

  let startPage;
  let endPage;

  if (pages - (spread * 2) < 6) {
    startPage = 1;
    endPage = pages;
  } else {
    startPage = current - spread;
    endPage = current + spread;
    if (startPage < 1) {
      endPage -= startPage - 1;
    }
    if (endPage > pages) {
      startPage -= endPage - pages;
    }
    if (startPage < 4) {
      startPage = 1;
    }
    if (endPage > pages - 3) {
      endPage = pages;
    }
  }

  const iterPages = [...Array(endPage - startPage + 1).keys()].map((p) => p + startPage);

  return (
    <Menu pagination {...rest}>
      <Menu.Item as="a" icon disabled={current === 1}>
        <Icon name="chevron left" />
      </Menu.Item>
      {startPage > 1 && (
        <React.Fragment>
          <Menu.Item as="a" icon>1</Menu.Item>
          <Menu.Item>...</Menu.Item>
        </React.Fragment>
      )}
      {iterPages.map((p) => (
        <Menu.Item key={p} as="a" icon active={p === current}>{p}</Menu.Item>
      ))}
      {endPage < pages && (
        <React.Fragment>
          <Menu.Item>...</Menu.Item>
          <Menu.Item as="a" icon>{pages}</Menu.Item>
        </React.Fragment>
      )}
      <Menu.Item as="a" icon disabled={current === pages}>
        <Icon name="chevron right" />
      </Menu.Item>
    </Menu>
  );
};

export default PaginationMenu;

PaginationMenu.defaultProps = {
  current: 1,
  spread: 2,
};
